module.exports = __webpack_public_path__ + "img/Prym-Soft250.94f3812c.png";